module.exports = __webpack_public_path__ + "static/media/logo-light.51f6982b.png";